export const envDefaults = {
  apiUrl: process.env.REACT_APP_BACKEND_API_URL,
  serverUrl: process.env.REACT_APP_BACKEND_SERVER_URL,

  microsoftClientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
};

